<template>
  <v-dialog v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title ? title : $t("Import.import", [objName]) }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-list-item three-line>
          <v-list-item-content>
            <!-- 选择分账类型 -->
            <v-list-item-title
              class="text-left my-2"
              v-if="
                settings &&
                settings.sub_account_enable == 1 &&
                settings.sub_account_split_type === 0
              "
            >
              {{ $t("Template.chooseSubAccountType") }}
            </v-list-item-title>
            <v-list-item-subtitle
              v-if="
                settings &&
                settings.sub_account_enable == 1 &&
                settings.sub_account_split_type === 0
              "
            >
              <SearcherSubAccountType v-model="sub_account_type" />
            </v-list-item-subtitle>
            <v-list-item-title class="text-left my-2" v-if="!hideDownload">
              {{ $t("Import.downloadFieldTemplate", [objName]) }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="!hideDownload">
              <v-btn
                v-if="downloadFromAPI"
                color="primary"
                dark
                class="ms-1"
                @click="
                  $emit(
                    'download',
                    settings &&
                      settings.sub_account_enable == 1 &&
                      settings.sub_account_split_type === 0
                      ? sub_account_type
                      : ''
                  )
                "
              >
                {{ $t("Import.downloadFieldTemplateBtn") }}
              </v-btn>
              <v-btn
                v-else
                color="primary"
                dark
                class="ms-1"
                :href="$BaseURL + downloadTemplateUrl"
              >
                {{ $t("Import.downloadFieldTemplateBtn") }}
              </v-btn>
            </v-list-item-subtitle>
            <v-list-item-title class="text-left my-2">
              {{ $t("Import.uploadField", [objName]) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-file-input
                v-model="excelFile"
                show-size
                :label="$t('Import.fileInputLabel')"
                accept=".xls,.xlsx"
              ></v-file-input>
            </v-list-item-subtitle>
            <span v-if="isTips">
              <v-list-item-title class="text-left my-2">
                {{ $t("$vuetify.alert") }}
              </v-list-item-title>
              <v-list-item-subtitle
                class="text-left my-1"
                v-for="detail in tipDetails"
                :key="detail"
              >
                {{ detail }}
              </v-list-item-subtitle>
            </span>
            <span v-if="isHint" class="text-left my-1 red--text">
              {{ hintDetail }}
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="primary"
          depressed
          @click="
            settings &&
            settings.sub_account_enable == 1 &&
            settings.sub_account_split_type === 0
              ? $emit('import', {
                  excel: excelFile,
                  sub_account_type: sub_account_type,
                })
              : $emit('import', { excel: excelFile })
          "
        >
          {{ $t("Import.confirmImport") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import SearcherSubAccountType from "@/components/subAccountSettings/plugins/SearcherSubAccountType";

export default {
  name: "ImportExcelDialog",

  props: {
    value: Boolean,
    title: String,
    objName: String,
    isTips: Boolean,
    isHint: Boolean,
    tipDetails: Array,
    downloadFromAPI: Boolean,
    downloadTemplateUrl: String,
    hintDetail: String,
    hideDownload: Boolean,
  },

  data: () => ({
    dialog: false,
    excelFile: null,
    sub_account_type: null,
  }),
  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  components: {
    SearcherSubAccountType,
  },
  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.excelFile = null;
          this.sub_account_type = null;
        }
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>